import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './HomecardContentSeparator.module.scss';

const HomecardContentSeparator = ({ theme = 'base' }) => (
  <span
    className={classNames(
      styles['homecard-content-separator'],
      styles[`homecard-content-separator--${theme}`]
    )}
  >
    &#9632;
  </span>
);

HomecardContentSeparator.propTypes = {
  theme: PropTypes.oneOf(['base', 'medium'])
};

export default HomecardContentSeparator;
